import {
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { ProductModel } from '../models/product.model';

@Component({
  selector: 'app-product-details-details',
  template: `
    <div>
      <h2 class="detailsHeader">Details</h2>
      <div class="detailsButtons">
        <button [attr.aria-selected]="overviewSelected" [ngClass]="overviewClass" (click)="this.getClass(true)">Overview</button>
        <button [attr.aria-selected]="benefitsSelected" [ngClass]="benefitsClass" (click)="this.getClass(false)">Benefits & Features</button>
      </div>
      <div class="detailsText" *ngIf="showOverview" [innerHTML]="this.model.iscommercial ? this.model.overview : this.model.resOverview"></div>
      <div class="detailsText" *ngIf="!showOverview" [innerHTML]="this.model.iscommercial ? this.model.benefitsFeatures : this.model.resBenefitsFeatures"></div>
    </div>
  `,
  styles: [
    `
      .detailsHeader {
        color: #4a4a4a;
        font-family: 'LGEIBold';
        font-size: 32px;
        text-align: left;
      }

      .detailsButtons {
        display: flex;
        flex-flow: row nowrap;
      }

      .detailButtonSelected {
        flex: 0 0 50%;
        box-sizing: border-box;
        background-color: #a50034;
        color: #ffffff;
        font-family: 'LGEIRegular';
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        border: 1px solid #a50034;
        cursor: pointer;
        display: inline-block;
        padding: .5rem;
      }

      .detailButtonUnselected {
        flex: 0 0 50%;
        box-sizing: border-box;
        background-color: #fff;
        color: #a50034;
        font-family: 'LGEIRegular';
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        border: 1px solid #a50034;
        cursor: pointer;
        display: inline-block;
        padding: .5rem;
      }

      .detailsText {
        color: #4a4a4a;
        font-family: 'LGEIRegular';
        font-size: 20.1px;
        line-height: 1.5;
        margin-top: 10px;
      }
    `
  ]
})
export class ProductDetailsDetailsComponent implements OnChanges {
  @Input() model: ProductModel;
  @Input() iscommercial: string;
  @Input() productClass: string;

  overviewClass = 'detailButtonSelected';
  benefitsClass = 'detailButtonUnselected';

  overviewSelected = false;
  benefitsSelected = false;

  showOverview: Boolean = true;


  ngOnChanges() {
    this.overviewClass = 'detailButtonSelected';
    this.overviewSelected = true;
    this.benefitsClass = 'detailButtonUnselected';
    this.showOverview = true;
  }

  getClass(isoverviewSelected: Boolean) {
    if (isoverviewSelected) {
      this.overviewClass = 'detailButtonSelected';
      this.overviewSelected = true;
      this.benefitsClass = 'detailButtonUnselected';
      this.benefitsSelected = false;
      this.showOverview = true;
    } else {
      this.overviewClass = 'detailButtonUnselected';
      this.overviewSelected = false;
      this.benefitsClass = 'detailButtonSelected';
      this.benefitsSelected = true;
      this.showOverview = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/components/product-details-details.component.ts